import { render, staticRenderFns } from "./chatReport.vue?vue&type=template&id=fb61fd16&scoped=true"
import script from "./chatReport.vue?vue&type=script&lang=js"
export * from "./chatReport.vue?vue&type=script&lang=js"
import style0 from "./chatReport.vue?vue&type=style&index=0&id=fb61fd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb61fd16",
  null
  
)

export default component.exports